import { listForms } from '@wix/ambassador-forms-v4-form/http';
import { Fieldset } from '@wix/ambassador-forms-v4-form/types';
import pRetry from 'p-retry';
import { toError } from '../common/error';
import { ControllerError } from './errors';
import { extractHttpErrorDetails, isHttpError } from './http-error';
export const fetchForms = async ({ formIds, formKind, namespace, httpClient, errorMonitor, throwWhenFormMissing = true, additionalMetadata, errorHandler, language })=>{
    const getForms = async ()=>{
        const headers = language ? {
            'X-Wix-Language': language
        } : {};
        try {
            const { data } = await pRetry(async ()=>{
                try {
                    return await errorHandler.withErrorHandler(()=>httpClient.request((args)=>({
                                ...listForms({
                                    formIds,
                                    namespace,
                                    kind: formKind,
                                    fieldsets: [
                                        Fieldset.NESTED_FORMS
                                    ],
                                    additionalMetadata
                                })(args),
                                headers
                            })), {
                        errorCodesMap: {}
                    });
                } catch (error) {
                    if (isHttpError(error) && error.response?.status === 429) {
                        throw new pRetry.AbortError(error);
                    }
                    throw error;
                }
            }, {
                retries: 3,
                onFailedAttempt: (error)=>{
                    errorHandler.reportRetryAttempt(error);
                }
            });
            return data.forms ?? [];
        } catch (error) {
            if (isHttpError(error)) {
                const httpError = extractHttpErrorDetails(error);
                errorMonitor.captureException(new Error(`Could not fetch forms`), {
                    contexts: {
                        ...httpError && {
                            httpError
                        }
                    }
                });
            } else {
                errorMonitor.captureException(toError(error));
            }
            errorHandler.showError(error);
            throw new ControllerError('Could not fetch forms', error);
        }
    };
    const forms = await getForms();
    const formsById = forms.reduce((result, form)=>{
        if (form.id) {
            result[form.id] = form;
        }
        return result;
    }, {});
    const hasMissingForm = formIds.find((formId)=>!formsById[formId]);
    if (throwWhenFormMissing && hasMissingForm) {
        const errorMessage = 'One or more forms are missing in the server response';
        errorMonitor.captureException(new Error(errorMessage));
        throw new ControllerError(errorMessage);
    }
    return formsById;
};

//# sourceMappingURL=fetch-forms.js.map